module.exports = __webpack_public_path__ + "static/media/20ECE9.e2739fd9.jpg";